<!--
 * @Author: ljc_625738144@qq.com
 * @Date: 2023-09-27 15:43:17
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2025-07-03 14:44:11
 * @Description:
 * @FilePath: \haozhang_pro\src\pages\voucher\addVoucher.vue
-->
<template>
	<div id="addVoucher" >
		<div class="title">
			<h2>{{titles}}</h2>
			<span>{{loadstatus.voucherData.year}}年{{loadstatus.voucherData.periods}}期</span>
		</div>
		<voucher-content @on-world-change="getworldKey" ref="voucherModel"></voucher-content>
	</div>
</template>

<script>
import voucherContent from '@/components/table/voucherTableContent';
import {mapState} from 'vuex'
export default {
	data(){
		return {
			voucher:{
				yearPeriods:'',
				year:'',
				periods:'',
				number:'',
			},
			titles:'记账凭证',
		}
	},
	components:{
		voucherContent
	},
	computed:{
		...mapState([
			'loadstatus'
		])
	},
	created(){
		// this.init();
		this.$store.commit('UPDATAVOUCHEREDIT',false);
	},
	activated() {
	},
	methods:{
		init(){
			const _=this;
			_.initVouchers();
		},//凭证表初始化数据
		initVouchers(){
			const _=this;
			_.$http.post('voucherChief/initializationVoucher',{}).then((res)=>{
				if(res && res.data.code == '1'){
					let datas = res.data.data;
					datas.date = _.$util.formatDate.format(datas.date,'yyyy-MM-dd');
					_.$setSessionStorage('voucher',res.data.data);
					_.$resert(_.voucher,datas);
				}
			}).catch((e)=>{

			});
		},
		getworldKey(val){
			this.titles = val;
		}
	},
	mounted() {

	},
	deactivated(){
	},

}
</script>

<style lang="less">
	#addVoucher {
		.title {
			width: 1300px;
			margin:0 auto;
			text-align: center;
			margin-bottom: 20px;
			margin-top: 50px;
			position: relative;
			h2,span {
				display: inline-block;
			};
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/voucher/addVoucher.vue